import { getRequest, postRequest, putRequest } from "./performanceApiClient";

export const listCampaigns = async (params = {}) =>
  getRequest("/360/campaigns", { params });

export const getCampaignById = async (campaignId) =>
  getRequest(`/360/campaigns/${campaignId}`);

export const createCampaign = async (payload) =>
  postRequest("/360/campaigns", payload);

export const updateCampaign = async (campaignId, payload) =>
  putRequest(`/360/campaigns/${campaignId}`, payload);

export const list360Reviews = async (params = {}) =>
  getRequest("/360/reviews", { params });

export const submit360Review = async (payload) =>
  postRequest("/360/reviews", payload);

export default {
  listCampaigns,
  getCampaignById,
  createCampaign,
  updateCampaign,
  list360Reviews,
  submit360Review,
};
